module.exports = __webpack_public_path__ + "static/media/MUSEAbadge-black-p-1080.2ff2732e.jpeg";